<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header />
    <Content />
    <Footer />
  </div>
</template>

<script>
import Header from 'components/invoiceExtendDueDateSoldOutRequests/Header'
import Content from 'components/invoiceExtendDueDateSoldOutRequests/Content'
import Footer from 'components/invoiceExtendDueDateSoldOutRequests/Footer'

export default {
  name: 'InvoiceExtendDueDateSoldOutRequests',
  components: {
    Header,
    Content,
    Footer
  },
  computed: {
    height () {
      return document.body.offsetHeight
    }
  },
  methods: {
    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    }
  },
  mounted () {
    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>
